import { useEffect, useState } from "react";

function useTimeCount() {
  const [state, setState] = useState({ x: 0, y: 0 });
  const [move, setMove] = useState({ x: 0, y: 0 });
  const [count, setCount] = useState(0);

  useEffect(() => {
    window.addEventListener("mousemove", (e) => {
      setState({ x: e.clientX, y: e.clientY });
    });
    window.addEventListener("mousemove", (e) => {
      setTimeout(() => {
        setMove({ x: e.clientX, y: e.clientY });
      }, 2000);
    });
  }, []);

  useEffect(() => {
    let timer;
    if (state.x === move.x && state.y === move.y) {
      timer = setTimeout(() => {
        setCount(count + 2);
      }, 2000);
    } else {
      timer = setTimeout(() => {
        setCount(0);
      }, 0);
    }

    return () => clearTimeout(timer);
  }, [count, move.x, move.y, state.x, state.y]);

  // useEffect(() => {
  //   if (state.x === move.x && state.y === move.y) {
  //     setTimeout(() => {
  //       setCount(count + 3);
  //     }, 3000);
  //   } else {
  //     setCount(0);
  //   }
  // }, [count, move.x, move.y, state.x, state.y]);

  return count;
}

export default useTimeCount;
